var _rect, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgComercio = function SvgComercio(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#FFECE8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5034 30.25C29.5041 25.2079 34.2014 21.5 40 21.5C45.7986 21.5 50.5028 25.2079 50.5034 30.25H46.6883C46.6883 27.0411 43.693 24.8188 40.0028 24.8188C36.3125 24.8188 33.3247 27.0411 33.3247 30.25H29.5034Z",
    fill: "#E76F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 30.25H57.5V53.1898C57.5 55.3342 56.3328 56.427 54 56.468C51.6672 56.509 42.3328 56.509 26 56.468C23.6673 56.468 22.5 55.3753 22.5 53.1898V30.25ZM46.6883 33.5315H50.5034C50.4982 38.9642 45.7992 43.3668 40.0034 43.3668C34.2077 43.3668 29.5087 38.9642 29.5034 33.5315H33.3247C33.3308 36.9865 36.32 39.7856 40.0065 39.7856C43.6931 39.7856 46.6823 36.9865 46.6883 33.5315Z",
    fill: "#E76F00"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgComercio, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/comercio.de5aed6b.svg";
export { ForwardRef as ReactComponent };